import { action } from "../../../utils/actions";

export const OPEN_AGREEMENT_PAGE = action("OPEN_AGREEMENT_PAGE");
export const ACCEPT_AGREEMENT = action("ACCEPT_AGREEMENT");
